import CourseHeader from './course-header';

export default CourseHeader;
